import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  GenerationState,
  generationStepAdapter,
  UIGenerationStep
} from '../../reducers/generations/generation.reducer';

const selectGenerationFeature = createFeatureSelector<GenerationState>('generations');

const { selectAll, selectEntities, selectIds } = generationStepAdapter.getSelectors(
  createSelector(selectGenerationFeature, (state: GenerationState) => state.generationSteps)
);

const selectAllGenerations = createSelector(selectGenerationFeature, (state: GenerationState) =>
  Object.values(state.generations)
);

const selectGeneration = createSelector(selectGenerationFeature, (state: GenerationState) => {
  const currentGenerationId = state.currentGenerationId;
  return state.generations[currentGenerationId];
});

const selectAllGenerationSteps = createSelector(selectAll, (steps: UIGenerationStep[]) => steps);

const selectGenerationStepByKey = (stepKey: string) => createSelector(selectEntities, (entities) => entities[stepKey]);

const selectGenerationById = (generationId: string) =>
  createSelector(selectGenerationFeature, (state: GenerationState) => state.generations[generationId]);

const selectAllGenerationStepIds = createSelector(selectIds, (steps: string[]): string[] => steps);

const selectUnderManualNavigationControl = createSelector(
  selectGenerationFeature,
  (state: GenerationState) => state.underManualNavigationControl
);

export const GenerationSelectors = {
  selectAllGenerations,
  selectGeneration,
  selectAllGenerationSteps,
  selectGenerationStepByKey,
  selectGenerationById,
  selectAllGenerationStepIds,
  selectUnderManualNavigationControl
};
